import { option, record } from 'fp-ts';
import { pipe } from 'fp-ts/function';

export const omitFalsyValues = <T>(data: Record<string, T>) =>
    pipe(
        data,
        // eslint-disable-next-line
        record.map((item) => (Boolean(item) ? item : null)),
        record.map(option.fromNullable),
        record.compact
    );
